import { useMutation } from '@tanstack/react-query'

import { createCategoryOfPurchaseApplicationTemplate } from '@src/api'
import { useAxios } from '@src/hooks/use-axios'

import { MutationCreateCategoryOfPurchaseApplicationTemplateArgs } from './type'

export const useCreateCategoryOfPurchaseApplicationTemplate = () => {
  const { axiosInstance } = useAxios()
  return useMutation({
    mutationFn: ({
      params,
      organizationId,
    }: MutationCreateCategoryOfPurchaseApplicationTemplateArgs) =>
      createCategoryOfPurchaseApplicationTemplate(axiosInstance, {
        organizationId,
        createCategoryOfThePurchaseApplicationTemplateRequest: params,
      }),
  })
}
